export default __webpack_public_path__ + "static/3-e536a95194a26267bdb10e1741b91bbf.png";